import React from "react";
import { Layout } from "@arco-design/web-react";
import { FooterProps } from "@arco-design/web-react/es/Layout/interface";
import cs from "classnames";
import "./style/index.less";

function Footer(props: FooterProps = {}) {
  const { className, ...restProps } = props;
  return (
    <Layout.Footer
      className={cs("footer", className)}
      //footer可填充
      {...restProps}></Layout.Footer>
  );
}

export default Footer;
